import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const MassagePricing = () => {
  
  return (
    <>
  {/* Page Wrapper */}
  <div id="wrapper">
    {/* Sidebar */}
   <Sidebar/>
    {/* End of Sidebar */}
    {/* Content Wrapper */}
    <div id="content-wrapper" className="d-flex flex-column">
      {/* Main Content */}
      <div id="content">
        {/* Topbar */}
       <Header/>
        {/* End of Topbar */}
        {/* Begin Page Content */}
        <div className="container-fluid">
  {/* Page Heading */}
  <h1 className="h3 mb-4 text-gray-800">Massage Pricing</h1>
  <div className="card">
    <div className="card-header">Pricing</div>
    <div className="card-body" style={{ background: "white" }}>
      <form action="massage_pricing.php" method="POST">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Price</label>
                <input
                  type="text"
                  name="txt_price"
                  className="form-control"
                  placeholder="Enter Price"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label>Duration</label>
                <input
                  type="text"
                  name="txt_duration"
                  className="form-control"
                  placeholder="Enter Duration"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>



        {/* /.container-fluid */}
      </div>
      {/* End of Main Content */}
      {/* Footer */}
     <Footer/>
      {/* End of Footer */}
    </div>
    {/* End of Content Wrapper */}
  </div>
  {/* End of Page Wrapper */}
  {/* Scroll to Top Button*/}
 
</>

  );
};
